import {gql} from "@apollo/client";

export const GetChatConversationInboxQuery = gql`
    query GetChatConversationInbox($chatConversationInboxInputDto: ChatConversationInboxInputDto!) {
        getChatConversationInbox(ChatConversationInboxInputDto: $chatConversationInboxInputDto) {
            id
            sourceId
        }
    }
`;
